import "./style.scss";

import { ProductStockout } from "./product-stockout";
import { Article } from "../../../model/article";
import { StockoutProductSimulationResult } from "./stockout-product-simulation-result";
import { stocksService } from "../../../services/stocks";
import { sumBy } from "lodash";
import { Stockout } from "../../../model/stockout";

export class CreateProductStockout extends ProductStockout {

    public async simulateAction(deliveryOrderIds: number[], article: Article, quantity: number): Promise<StockoutProductSimulationResult> {
        const stockoutSimulationResult = await stocksService.bulkStockoutSimulation(
            this.props.operationCode,
            this.props.batchId,
            article.id,
            deliveryOrderIds,
            quantity,
        );

        return new StockoutProductSimulationResult(
            sumBy(stockoutSimulationResult, element => element.quantity),
            stockoutSimulationResult.length,
        );
    }

    public async executeAction(deliveryOrderIds: number[], article: Article, quantity: number): Promise<Stockout[]> {
        return stocksService.bulkStockout(
                this.props.operationCode,
                this.props.batchId,
                article.id,
                deliveryOrderIds,
                quantity,
            );
    }
}
